// import Loader from 'common/components/Loader/Loader';
import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import fetchJSON from "common/utils/fetchJSON";
import ConfigurationForm from "./ConfigurationForm";

function Configuration() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const [isFetching, setIsFetching] = useState(false);
  const [configurationValues, setConfigurationValues] = useState<any>();
  const [configurationFields, setConfigurationFields] = useState<any>();

  const id = router.query.id as string;

  useEffect(() => {
    const fetchconfigurationDetails = async () => {
      setIsFetching(true);
      try {
        const infos = await fetchJSON({
          url: "configuration",
          method: "GET",
        });
        setConfigurationValues({
          id: infos.data.id,
          ...infos.data.attributes,
        });

        const fields = await fetchJSON({
          url: "content-type-builder/content-types/api::configuration.configuration",
          method: "GET",
        });
        setConfigurationFields(fields?.data?.schema?.attributes);
      } catch (error) {
        console.error(error);
      } finally {
        setIsFetching(false);
      }
    };

    fetchconfigurationDetails();
  }, []);

  const onSubmit = useCallback(async (values: any) => {
    try {
      await fetchJSON({
        url: "configuration",
        method: "PUT",
        payload: {
          data: values,
        },
      });
    } catch (e: any) {
      return e;
    }
    return true;
  }, []);

  return isFetching || !configurationValues || !configurationFields ? null : (
    <ConfigurationForm
      onSubmit={onSubmit}
      configuration={configurationValues}
      configurationFields={configurationFields}
    />
  );
}

export default Configuration;
